'use strict';
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dFor$002dOrg$002dMember$0024$0024anon$00241 from "./app.data.-App-Auth-Data$-For-Org-Member$$anon$1.js";
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dFor$002dOrg$002dMember$0024$0024anon$00242 from "./app.data.-App-Auth-Data$-For-Org-Member$$anon$2.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppAuthData$ForOrgMember$() {
  this.axu = null;
  this.axv = false;
  this.axw = null;
  this.axx = false;
}
export { $c_Lapp_data_AppAuthData$ForOrgMember$ as $c_Lapp_data_AppAuthData$ForOrgMember$ };
$p = $c_Lapp_data_AppAuthData$ForOrgMember$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppAuthData$ForOrgMember$;
/** @constructor */
function $h_Lapp_data_AppAuthData$ForOrgMember$() {
}
export { $h_Lapp_data_AppAuthData$ForOrgMember$ as $h_Lapp_data_AppAuthData$ForOrgMember$ };
$h_Lapp_data_AppAuthData$ForOrgMember$.prototype = $p;
$p.ym = (function() {
  if ((!this.axv)) {
    this.axu = new $j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dFor$002dOrg$002dMember$0024$0024anon$00241.$c_Lapp_data_AppAuthData$ForOrgMember$$anon$1();
    this.axv = true;
  }
  return this.axu;
});
$p.yr = (function() {
  if ((!this.axx)) {
    this.axw = new $j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dFor$002dOrg$002dMember$0024$0024anon$00242.$c_Lapp_data_AppAuthData$ForOrgMember$$anon$2();
    this.axx = true;
  }
  return this.axw;
});
var $d_Lapp_data_AppAuthData$ForOrgMember$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppAuthData$ForOrgMember$, "app.data.AppAuthData$ForOrgMember$", ({
  z9: 1
}));
export { $d_Lapp_data_AppAuthData$ForOrgMember$ as $d_Lapp_data_AppAuthData$ForOrgMember$ };
var $n_Lapp_data_AppAuthData$ForOrgMember$;
function $m_Lapp_data_AppAuthData$ForOrgMember$() {
  if ((!$n_Lapp_data_AppAuthData$ForOrgMember$)) {
    $n_Lapp_data_AppAuthData$ForOrgMember$ = new $c_Lapp_data_AppAuthData$ForOrgMember$();
  }
  return $n_Lapp_data_AppAuthData$ForOrgMember$;
}
export { $m_Lapp_data_AppAuthData$ForOrgMember$ as $m_Lapp_data_AppAuthData$ForOrgMember$ };
//# sourceMappingURL=app.data.-App-Auth-Data$-For-Org-Member$.js.map
